import styled from "styled-components";

export const Styles = styled.div`
  padding-top: 10px;
`;
